<template>
    <div>
        <h4>{{ Date.now() | moment('dddd Do MMMM') }}</h4>
        <b-form-textarea
            id="textarea"
            v-model="form.description"
            rows="3"
            max-rows="6"
        />
        <div class="row mt-3 mb-1">
            <div class="col-3">
                <b-form-group label="Affecter cette tâche à">
                    <b-form-select
                        v-model="form.assigned_to"
                        :options="assignmentsOptions"
                        size="sm"
                        style="height: 30px"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled
                                >-- Sélectionner un collaborateur --
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </div>
            <div class="col-3">
                <label>Echéance</label>
                <b-input-group>
                    <b-form-input
                        id="current-date"
                        v-model="formatted_deadline_date"
                        type="text"
                        placeholder="Date à définir"
                        autocomplete="off"
                        size="sm"
                        disabled
                        class="bg-white"
                        style="height: 30px"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-form-datepicker
                            v-model="form.deadline_date"
                            button-only
                            right
                            label-no-date-selected="Date à définir"
                            label-prev-year="Année précédente"
                            label-next-year="Année prochaine"
                            label-prev-month="Mois précédent"
                            label-next-month="Mois prochain"
                            label-current-month="Mois actuel"
                            label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                            start-weekday="1"
                            aria-controls="current-date"
                            locale="fr"
                            @context="formatDeadlineDate"
                        >
                        </b-form-datepicker>
                    </b-input-group-append>
                </b-input-group>
            </div>
            <div class="col-2">
                <label>Priorité</label>
                <b-form-select
                    v-model="form.priority"
                    :options="priorityOptions"
                    size="sm"
                    style="height: 30px"
                />
            </div>
            <div class="col-1">
                <b-form-group>
                    <label>Budget (h)</label>
                    <b-input v-model="form.budgeted_duration"
                             type="numeric"
                             step="0.1"
                             size="sm"
                             class="text-right" />
                </b-form-group>
            </div>
            <div class="col-3">
                <b-form-group>
                    <label>
                        Facturation de la tâche
                        <b-link
                            title="Si la tâche est facturable, sélectionner la rubrique de facturation"
                            class="text-primary ml-2"
                        >
                            <i class="far fa-info-circle"></i>
                        </b-link>
                    </label>
                    <b-form-select
                        v-model="form.billing_option_id"
                        :options="billableTimeSheetsOptions"
                        size="sm"
                        style="height: 30px"
                    >
                        <template #first>
                            <b-form-select-option :value="null">
                                Tâche non facturable
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </div>
        </div>
        <b-button variant="success" size="sm" @click="saveEvent">
            <i class="far fa-save fa-fw"></i
            ><span class="ml-1">Enregistrer</span>
        </b-button>
        <b-button variant="secondary" size="sm" @click="close">
            <i class="far fa-times fa-fw"></i><span class="ml-1">Annuler</span>
        </b-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import { Datetime } from 'vue-datetime'
import DataUpdater from '../../../../dashboard/mixins/DataUpdater'

export default {
    // TODO : use vuelidate

    name: 'TaskCreate',

    components: {
        Datetime,
    },

    mixins: [DataUpdater],

    data() {
        return {
            form: {
                // assigned_to,
                // budgeted_duration,
                // billing_option_id,
                // priority
            },
            billable: false,
            formatted_deadline_date: '',
            priorityOptions: [
                { value: 'H', text: 'Haute' },
                { value: 'N', text: 'Normale' },
                { value: 'Z', text: 'Basse' },
            ],
        }
    },

    created() {
        this.form.assigned_to = null
        this.form.budgeted_duration = 0
        this.form.billing_option_id = null
        this.form.priority = 'N'
    },

    methods: {
        async saveEvent() {
            try {
                this.form.client_id = this.clientId
                this.form.billable = this.form.billing_option_id !== null
                await axios.post('/clientEvents/task', this.form)
                this.close()
            } catch (error) {
                console.log(error)
            }
        },

        close() {
            this.$store.commit('browsing/RESET_EDITING')
            this.$store.commit('browsing/SET_PAGE_NAME', 'tasks.index')
            // this.updateData()
            this.$parent.getItems()
        },

        formatDeadlineDate(ctx) {
            this.formatted_deadline_date = ctx.selectedFormatted
        },
    },

    computed: {
        ...mapState({
            clientId: (state) => state.browsing.clientId,
            accountingFirmUsers: (state) =>
                state.data.options.accountingFirmUsers,
            billableTimeSheetsOptions: (state) =>
                state.data.options.billableTimeSheets,
        }),

        assignmentsOptions() {
            return this.accountingFirmUsers.filter((item) => item.value !== 0)
        },

        billingSwitchTitle() {
            return this.billable ? 'Tâche facturable' : 'Tâche non facturable'
        },

        formattedDateTime() {
            const dt = new Date(this.ISODateTime)
            const Y = dt.getFullYear()
            const m =
                dt.getMonth() + 1 < 10
                    ? `0${(dt.getMonth() + 1).toString()}`
                    : (dt.getMonth() + 1).toString()
            const d =
                dt.getDate() < 10
                    ? `0${dt.getDate().toString()}`
                    : dt.getDate().toString()
            const H =
                dt.getHours() < 10
                    ? `0${dt.getHours().toString()}`
                    : dt.getHours().toString()
            const i =
                dt.getMinutes() < 10
                    ? `0${dt.getMinutes().toString()}`
                    : dt.getMinutes().toString()
            return `${Y}-${m}-${d} ${H}:${i}`
        },
    },
}
</script>

<style scoped>
.card-header-item {
    background-color: #1f5c99;
    font-size: 12px;
    font-weight: bold;
    color: #fff;
}
</style>
